export default __webpack_public_path__ + "static/media/disco_dance_dla_dzieci-1.d4ca8dda.jpg";